import styled, { css } from 'styled-components';

import { HorizontalCenterBlock } from '../../styled';

export const DeleteButtonWrapper = styled(HorizontalCenterBlock)`
  margin-top: 44px;
  margin-bottom: 20px;
`;

export const Title = styled.div`
  ${(p) => p.theme.typography.accent};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: middle;
`;

export const ProjectIDWrapper = styled.span<{ disabled: boolean }>`
  ${(p) => p.theme.typography.body};
  width: min-content;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;

  ${(props) =>
    props.disabled
      ? css`
          :hover {
            color: ${(p) => p.theme.colors.text};
          }
        `
      : css`
          :hover {
            color: ${(p) => p.theme.colors.brand};
            cursor: pointer;
          }
        `}
`;
